const lsPrefix = '__wuji_source_ls_';
const getLsKey = key => [lsPrefix, key].join('');
export const ls = {
  set(key, data) {
    try {
      localStorage.setItem(getLsKey(key), JSON.stringify(data));
    } catch (error) {
      console.log('ls error:', error);
    }
  },
  get(key) {
    try {
      const str = localStorage.getItem(getLsKey(key));
      return str && JSON.parse(str);
    } catch (error) {
      console.log('ls error:', error);
      return null;
    }
  }
};
//# sourceMappingURL=ls.js.map
